import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DummyRefreshComponent } from './dummy-refresh/dummy-refresh.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./login-register-module/login-register-module.module').then(m => m.LoginRegisterModuleModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'dispatcher', loadChildren: () => import('./dispatcher/dispatcher.module').then(m => m.DispatcherModule) },
  { path: 'supervisor', loadChildren: () => import('./dispatcher/supervisor.module').then(m => m.SupervisorModule) },
  { path: 'contractadministrator', loadChildren: () => import('./dispatcher/contractadministrator.module').then(m => m.ContractAdministratorModule) },
  { path: 'profile', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },
  { path: 'customer', loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule) },
  { path: 'contracts', loadChildren: () => import('./contracts-management/contracts-management.module').then(m => m.ContractsManagementModule) },
  { path: 'foreman', loadChildren: () => import('./dispatcher/foreman-board/foreman-board.module').then(m => m.ForemanBoardModule) }
 , {
  path: 'refresh',
  component: DummyRefreshComponent // مكون وهمي فاضي
}

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class RoutingModule {
}
export const RoutingComponents = [];

export const Routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes);
